<div class="bfx-blotter__filter-manager__wrapper" style="width: 100%; height: 100%">
  <div
    #filterList
    class="bfx-blotter-filter-list"
    [blotterTypeId]="blotterTypeId"
    [multiSortMeta]="multiSortMeta"
    [extendedTypeId]="extendedTypeId"
  ></div>
  <div class="divider-wrapper" (mousedown)="dividerStart($event)">
    <div></div>
  </div>
  <div
    class="bfx-blotter-filter-view"
    [blotterTypeId]="blotterTypeId"
    [extendedTypeId]="extendedTypeId"
  ></div>
</div>
